import { capturePostHogEvent } from '@layers/common/app/utils/posthog'
/** This consent covers rewards telemetry only; it never registers push or grants coins. */
export function useRewardAnalytics() {
  const auth = useAuth()
  const enabled = useState('rewards-analytics-consent', () => false)
  const since = useState<number | null>('rewards-analytics-since', () => null)
  const key = computed(() => `exalted:rewards-analytics:${auth?.activeCustomer.value?.id ?? 'guest'}`)
  watch(key, (value) => {
    if (import.meta.server)
      return
    try {
      enabled.value = !!auth?.activeCustomer.value?.id && localStorage.getItem(value) === 'true'
      if (enabled.value) {
        const stored = Number(localStorage.getItem(`${value}:since`))
        // Existing consent without a timestamp starts now, never retroactively.
        since.value = stored > 0 && Number.isFinite(stored) ? stored : Date.now()
        localStorage.setItem(`${value}:since`, String(since.value))
      }
      else {
        since.value = null
      }
    }
    catch {
      enabled.value = false
      since.value = null
    }
  }, { immediate: true, flush: 'sync' })
  function setEnabled(value: boolean) {
    enabled.value = value && !!auth?.activeCustomer.value?.id
    since.value = enabled.value ? Date.now() : null
    try {
      localStorage.setItem(key.value, String(enabled.value))
      if (since.value)
        localStorage.setItem(`${key.value}:since`, String(since.value))
      else
        localStorage.removeItem(`${key.value}:since`)
    }
    catch { /* Consent remains valid only for this session if storage is unavailable. */ }
  }
  function track(event: string, properties: Record<string, string | number | boolean> = {}) {
    if (import.meta.client && enabled.value && auth?.activeCustomer.value?.id)
      capturePostHogEvent(event, properties)
  }
  return { enabled, since, setEnabled, track }
}
